import { fmtPKT } from "@/lib/time";
import useNotificationToasts from "./useNotificationToasts";

const configuration = {
  kind: "BOOKING_DOWN_PAYMENT_EXTENDED", prefix: "down-payment-extension",
  isEnabled: resource => !resource.toastsPaused && resource.data?.preferences?.down_payment_extension_toasts !== false,
  eligible: () => true,
  preferencesChangedAt: resource => resource.data?.preferences_updated_at,
  title: row => `Down payment deadline extended · ${row.booking_ref || row.booking_id}`,
  description: row => `New deadline: ${fmtPKT(row.due_at)}. Grace: ${row.grace_minutes} minutes. Reason: ${row.reason}`,
  actionLabel: "View booking details",
};

export default function useDownPaymentNotificationToasts(resource, onView, onFailure) {
  useNotificationToasts(resource, onView, onFailure, configuration);
}
